<script lang="ts">
    import { onMount } from 'svelte';
    import { idle, listen } from '@src/utils/idle.js';
    import { getAudio, playAudio, playAudioOnPageLoad, stopAudio } from '@src/utils/audio.js';
    import { GameStatus } from '@src/types/stringTypes';

    const SOUND_TRACKS = {
        IDLE: getAudio('audio_idle'),
        GAMEPLAY: getAudio('audio_gameplay')
    };

    const ambience = getAudio('audio_amb');

    export let autoBetStarted: boolean;
    export let gameStatus: GameStatus;

    let currentSound = SOUND_TRACKS.IDLE;
    let playbackId: number;
    let isPageActive = true;

    listen({
        timer: 25000, // 25 sec,
        cycle: 2000 // check once per sec.
    });

    const BACKGROUND_MUSIC_VOLUME = 0.3;

    onMount(() => {
        isPageActive && playAudioOnPageLoad(currentSound);

        if (isPageActive && !ambience.playing() && currentSound !== SOUND_TRACKS.GAMEPLAY) {
            ambience.volume(0.3)
            ambience.play();
        }

        return () => {
            stopAllBackgroundMusic();
            ambience.stop();
        };
    });

    const playBackgroundMusic = (sound: Howl) => {
        console.log('play');
        if (!sound.playing()) {
            playbackId = playAudio(
                sound,
                {
                    volume: BACKGROUND_MUSIC_VOLUME,
                    loop: true,
                    fade: { from: 0, to: BACKGROUND_MUSIC_VOLUME, duration: 3000 }
                },
                true
            );
            // stop all others sounds with fading
            Object.values(SOUND_TRACKS)
                .filter(track => track !== sound && track.playing())
                .forEach(track => stopWithFadingBackgroundMusic(track));
        }
    };

    const stopAllBackgroundMusic = () => Object.values(SOUND_TRACKS).forEach(track => track.stop());
    const stopWithFadingBackgroundMusic = (sound: Howl) => stopAudio(sound, { fade: { duration: 3000 } });
    const pauseBackgroundMusic = () => currentSound.pause();
    const resumeBackgroundMusic = (playbackId: number) =>
        playbackId && !currentSound.playing() && currentSound.play(playbackId);

    const onPageVisibilitychange = () => {
        isPageActive = !document.hidden;
        if (isPageActive) {
            Howler?.mute(false);
            playbackId && resumeBackgroundMusic(playbackId);
        } else {
            pauseBackgroundMusic();
            Howler?.mute(true);
        }
    };

    $: if (isPageActive) {
        if (gameStatus === 'STARTED' || autoBetStarted) {
            currentSound = SOUND_TRACKS.GAMEPLAY;
        } else if ($idle) {
            currentSound = SOUND_TRACKS.IDLE;
        }
    }

    $: if (isPageActive && currentSound) {
        playBackgroundMusic(currentSound);
    }

    // @TODO need refactoring
    $: if (currentSound === SOUND_TRACKS.GAMEPLAY) {
        ambience.stop();
    }
</script>

<svelte:window on:visibilitychange={onPageVisibilitychange} />
